export default __webpack_public_path__ + "b3e1aa3c047229355ef07e1c8e067dbd.png";